module.exports = __webpack_public_path__ + "2b218a99f4e966a83ce491dd2e9b8f76.png";